import ProjectedCrossesView from '../../features/projected-crosses/layouts/view';

// TSS vite/01 §"Pages are thin". /admin/projected-crosses — Catálogo · Ventas · Cola.
export default function ProjectedCrossesPage() {
    return <ProjectedCrossesView />;
}
